// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form .survey-form-section {
    margin-bottom: 30px;
    scroll-margin-top: calc(58px + env(safe-area-inset-top, 0));
}

.survey-form.survey-form-card-based .survey-form-section {
    background: #FFF;
    border-radius: 12px;
    margin-bottom: 20px;
}

.survey-form.survey-form-card-based .survey-form-section:last-child {
    margin-bottom: 0;
}

.survey-form.survey-form-v2 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 16px;
    align-items: flex-end;
    row-gap: 12px;
}

.survey-form.survey-form-v2 .survey-form-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    margin-bottom: 0;
}

.survey-form .survey-form-section:last-child {
    margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyForm/SurveyForm.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".survey-form .survey-form-section {\n    margin-bottom: 30px;\n    scroll-margin-top: calc(58px + env(safe-area-inset-top, 0));\n}\n\n.survey-form.survey-form-card-based .survey-form-section {\n    background: #FFF;\n    border-radius: 12px;\n    margin-bottom: 20px;\n}\n\n.survey-form.survey-form-card-based .survey-form-section:last-child {\n    margin-bottom: 0;\n}\n\n.survey-form.survey-form-v2 {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    column-gap: 16px;\n    align-items: flex-end;\n    row-gap: 12px;\n}\n\n.survey-form.survey-form-v2 .survey-form-section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    flex: 1;\n    margin-bottom: 0;\n}\n\n.survey-form .survey-form-section:last-child {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
